// extracted by mini-css-extract-plugin
export default {"collaborationModal":"collaboration-page_collaborationModal__qVUNr","bgDecorator":"collaboration-page_bgDecorator__ZbZ+-"};